// `T` and `never` must be wrapped in an array to handle this issue:
//   https://github.com/microsoft/TypeScript/issues/31751
export type ActionResultSuccess<T> = [T] extends [never]
  ? { success: true }
  : { success: true; data: T };

export type ActionResultError = {
  success: false;
  error: ActionError;
  detail?: string;
};

/**
 * Successful actions return `success: true` with data (if specified in the type definition) while
 * unsuccessful action return `success: false` with an error and optional details.
 */
export type ActionResult<Data = never> = ActionResultSuccess<Data> | ActionResultError;

export enum ActionError {
  // Newsletter
  INVALID_EMAIL,
  ALREADY_SUBSCRIBED,
  NOT_SUBSCRIBED,

  // Page authentication
  INVALID_PASSWORD,

  // General
  UNKNOWN,
}
